module.exports = require("core-js/library/fn/symbol/iterator");


/*****************
 ** WEBPACK FOOTER
 ** ./~/@babel/runtime-corejs2/core-js/symbol/iterator.js
 ** module id = 620
 ** module chunks = 0
 **/